import { inject, Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { SadmType } from '@pixacare/domain';

@Injectable({
  providedIn: 'root',
})
export class SadmTypeLabelService {
  private readonly translocoService = inject(TranslocoService);

  readonly sadmLabelsByType: Record<SadmType, string> = {
    [SadmType.WOUNDCARE]: this.translocoService.translate('lésion'),
    [SadmType.SCARSPY]: this.translocoService.translate('cicatrice'),
  };

  getLabel(sadmType: SadmType): string {
    return this.sadmLabelsByType[sadmType];
  }
}
